import type { TableProps } from "antd5";

/**
 * `showSorterTooltip` for every `TableWithFilters`.
 *
 * The table's `getPopupContainer` does not reach the sort tooltip, which falls
 * back to neonumy-ui's `ThemeProvider` and opens inside the header cell. With
 * `scroll.y` the header has `overflow: hidden`, so the tooltip is cut off.
 */
export const sorterTooltip: TableProps["showSorterTooltip"] = {
  getPopupContainer: () => document.body,
};
